/**
 * Branding der Installation (Name, Logo, App-Start) — einmal laden, überall nutzen.
 * Der Ladebildschirm in public/index.html legt die Daten unter dem gleichen
 * Cache-Key ab, deshalb ist der erste Render sofort korrekt.
 */
import { useEffect, useState } from 'react';

const CACHE_KEY = 'shop_brand_splash';
const API = process.env.REACT_APP_BACKEND_URL;

export const EMPTY_BRAND = {
  company_name: '',
  short_name: '',
  tagline: '',
  logo_url: '',
  theme_color: '#C9A23C',
  start_mode: 'home',
};

export const cachedBrand = () => {
  try {
    const raw = localStorage.getItem(CACHE_KEY);
    return raw ? { ...EMPTY_BRAND, ...JSON.parse(raw) } : null;
  } catch (e) {
    return null;
  }
};

export const fetchBrand = async () => {
  const res = await fetch(`${API}/api/shop/brand`);
  if (!res.ok) throw new Error('brand');
  const data = await res.json();
  try {
    localStorage.setItem(CACHE_KEY, JSON.stringify(data));
  } catch (e) { /* Speicher voll – egal */ }
  return { ...EMPTY_BRAND, ...data };
};

export const appIconUrl = (size = 192) => `${API}/api/shop/app-icon-${size}.png`;

export function useBrand() {
  const [brand, setBrand] = useState(() => cachedBrand() || EMPTY_BRAND);

  useEffect(() => {
    let alive = true;
    fetchBrand()
      .then((data) => { if (alive) setBrand(data); })
      .catch(() => {});
    return () => { alive = false; };
  }, []);

  return brand;
}
